import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/investigate";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }
  @Action
  async items(params: any) {
    return api.items(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
  @Action
  async save(params: any) {
    return api.save(params);
  }
  @Action
  async info(params: any) {
    return api.info(params);
  }
}
